import React from 'react';
import './Footer.css';

export const Footer = () => {
  return (
    <footer>
      <p>&copy; 2024 eRastro. Todos los derechos reservados.</p>
    </footer>
  );
};